import { ref, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-715c3118"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  key: 0,
  class: "handle-content"
};
import LogDetailModal from '@/views/logManage/components/LogDetailModal.vue';
import { queryLogDetail, queryLogList } from '@/api/logApi';
import { OK, reportEvent } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'LogTableBlock',
  setup(__props, {
    expose
  }) {
    const columns = [{
      title: '功能模块',
      dataIndex: 'logType',
      key: 'logType',
      width: 350
    }, {
      title: '操作类型',
      dataIndex: 'tag',
      key: 'tag',
      width: 350
    }, {
      title: '操作用户',
      dataIndex: 'creator',
      key: 'creator',
      width: 350
    }, {
      title: '操作时间',
      dataIndex: 'createDate',
      key: 'createDate'
    }, {
      title: '操作内容',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right'
    }];
    const dataSource = ref([]),
      pageIndex = ref(1),
      pageSize = ref(20),
      pageTotal = ref(0),
      searchObj = ref({}),
      tableRef = ref(),
      detailVisible = ref(false),
      editItem = ref([]);
    const getData = async () => {
        let startTime = new Date().getTime();
        let params = {
          pageNum: pageIndex.value,
          pageSize: pageSize.value
        };
        Object.keys(searchObj.value).forEach(item => {
          if (searchObj.value[item] || searchObj.value[item] === 0) {
            params = {
              ...params,
              [item]: searchObj.value[item]
            };
          }
        });
        try {
          const {
            data,
            code,
            count
          } = await queryLogList(params);
          if (code === OK) {
            pageTotal.value = count;
            dataSource.value = data;
            reportEvent({
              eventName: '_search',
              properties: {
                ui_name: '操作日志',
                app_name: '',
                return_duration: (new Date().getTime() - startTime) / 1000,
                query_status: 'succeed'
              }
            });
          } else {
            reportEvent({
              eventName: '_search',
              properties: {
                ui_name: '操作日志',
                app_name: '',
                return_duration: (new Date().getTime() - startTime) / 1000,
                query_status: 'failed'
              }
            });
          }
        } catch (e) {
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '操作日志',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'failed'
            }
          });
        }
      },
      searchData = async obj => {
        pageIndex.value = 1;
        searchObj.value = obj;
        await getData();
      },
      changePage = async (page, pageS) => {
        pageIndex.value = page;
        pageSize.value = pageS;
        await getData();
      },
      openDetail = async item => {
        try {
          const {
            data,
            code
          } = await queryLogDetail({
            id: item.id
          });
          if (code === OK) {
            editItem.value = data;
            detailVisible.value = true;
          }
        } catch (e) {}
      };
    onMounted(async () => {
      await getData();
    });
    expose({
      searchData
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_table, {
        bordered: "",
        columns: columns,
        "data-source": dataSource.value,
        "row-key": "id",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.dataIndex === 'handle' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_a_button, {
          type: "link",
          onClick: $event => openDetail(record)
        }, {
          default: _withCtx(() => [_createTextVNode("操作详情")]),
          _: 2
        }, 1032, ["onClick"])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["data-source"]), _createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageIndex.value,
        "onUpdate:current": _cache[0] || (_cache[0] = $event => pageIndex.value = $event),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        total: pageTotal.value,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "pageSize", "total", "show-total"]), _createVNode(LogDetailModal, {
        "modal-visible": detailVisible.value,
        "onUpdate:modal-visible": _cache[2] || (_cache[2] = $event => detailVisible.value = $event),
        "data-source": editItem.value
      }, null, 8, ["modal-visible", "data-source"])]);
    };
  }
});